module.exports = __webpack_public_path__ + "img/andy.ed993b88.png";